export const QA_NAME_DASHBOARD_BIRDVIEW = 'dashboardBirdview'

export const QA_NAME_DASHBOARD_BIRDVIEW_TILE = 'dashboardBirdviewTile'

export const QA_NAME_DASHBOARD_BIRDVIEW_ROW_ACTION =
  'dashboardBirdviewRowAction'

export const QA_NAME_DASHBOARD_BIRDVIEW_SHOW_ALL = 'dashboardBirdviewShowAll'

export const QA_NAME_DASHBOARD_BIRDVIEW_ENTITY_TITLE =
  'dashboardBirdviewEntityTitle'

export const QA_NAME_DASHBOARD_BIRDVIEW_DRAG_HANDLE =
  'dashboardBirdviewDragHandle'

export const QA_NAME_DASHBOARD_BIRDVIEW_CARD_INFO = 'dashboardBirdviewCardInfo'

export const QA_NAME_DASHBOARD_BIRDVIEW_HOME_COPY = 'dashboardBirdviewHomeCopy'

export const QA_NAME_DASHBOARD_BIRDVIEW_HOME_LINK = 'dashboardBirdviewHomeLink'

export const QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_ROW =
  'dashboardBirdviewAttentionRow'

export const QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_TOGGLE =
  'dashboardBirdviewAttentionToggle'

export const QA_NAME_DASHBOARD_BIRDVIEW_RETRY = 'dashboardBirdviewRetry'

export const QA_NAME_DASHBOARD_BIRDVIEW_REFRESH = 'dashboardBirdviewRefresh'

export const QA_NAME_DASHBOARD_BIRDVIEW_SCOPE_MINE =
  'dashboardBirdviewScopeMine'

export const QA_NAME_DASHBOARD_BIRDVIEW_SCOPE_TEAM =
  'dashboardBirdviewScopeTeam'

export const QA_NAME_DASHBOARD_BIRDVIEW_VIEW_DASHBOARD =
  'dashboardBirdviewViewDashboard'

export const QA_NAME_DASHBOARD_BIRDVIEW_VIEW_ANALYTICS =
  'dashboardBirdviewViewAnalytics'

export const QA_NAME_DASHBOARD_BIRDVIEW_PERIOD = 'dashboardBirdviewPeriod'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_PERIOD =
  'dashboardBirdviewChartPeriod'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_METRIC =
  'dashboardBirdviewChartMetric'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_ACTIONS =
  'dashboardBirdviewChartActions'

export const QA_NAME_DASHBOARD_BIRDVIEW_RESET_LAYOUT =
  'dashboardBirdviewResetLayout'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG =
  'dashboardBirdviewChartCatalog'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_SEARCH =
  'dashboardBirdviewChartCatalogSearch'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_TAB =
  'dashboardBirdviewChartCatalogTab'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ROW =
  'dashboardBirdviewChartCatalogRow'

export const QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ADD_CARD =
  'dashboardBirdviewChartCatalogAddCard'

export const QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_COLUMN =
  'dashboardBirdviewResizeColumn'

export const QA_NAME_DASHBOARD_BIRDVIEW_RESIZE_ROW =
  'dashboardBirdviewResizeRow'

export const QA_NAME_DASHBOARD_BIRDVIEW_TILE_DELTA =
  'dashboardBirdviewTileDelta'

export const QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE =
  'dashboardBirdviewGretaApprove'

export const QA_NAME_DASHBOARD_BIRDVIEW_GRETA_EDIT =
  'dashboardBirdviewGretaEdit'

export const QA_NAME_DASHBOARD_BIRDVIEW_GRETA_REJECT =
  'dashboardBirdviewGretaReject'

export const QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE_ALL =
  'dashboardBirdviewGretaApproveAll'
